import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                K
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">Kakobuy Finds</span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer.quick_links')}</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Strona Główna
              </Link>
              <Link to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik-2026" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Przewodnik Kakobuy
              </Link>
              <Link to="/artykul/jak-korzystac-z-kakobuy-spreadsheet" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Poradnik użytkownika
              </Link>
              <Link to="/artykul/kakobuy-spreadsheet-porownanie-arkuszy-2026" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Porównanie arkuszy
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Kakobuy Sheet
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Kategorie</h4>
            <div className="grid grid-cols-2 gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Buty
              </a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Bluzy/Swetry
              </a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Koszulki
              </a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Kurtki
              </a>
              <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Akcesoria
              </a>
              <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Torby
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Artykuły</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik-2026" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Kompletny przewodnik
              </Link>
              <Link to="/artykul/jak-korzystac-z-kakobuy-spreadsheet" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Poradnik krok po kroku
              </Link>
              <Link to="/artykul/kakobuy-spreadsheet-porownanie-arkuszy-2026" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Porównanie 2026
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 text-center">
          <p className="text-xs text-secondary-400">
            &copy; 2026 Kakobuy Finds. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}